import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.svg'


const _hoisted_1 = { class: "p-0" }
const _hoisted_2 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_3 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_4 = { class: "flex flex-col mt-6 text-sm gap-4" }
const _hoisted_5 = { class: "text-black-lp-300" }
const _hoisted_6 = { class: "font-medium mb-1" }
const _hoisted_7 = { class: "text-black-lp-300 flex" }
const _hoisted_8 = { class: "w-1/2 mr-1" }
const _hoisted_9 = { class: "font-medium mb-1" }
const _hoisted_10 = { class: "w-1/2 ml-1" }
const _hoisted_11 = { class: "font-medium mb-1" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "text-black-lp-300 mr-1 w-1/2" }
const _hoisted_14 = { class: "font-medium mb-1" }
const _hoisted_15 = { class: "text-black-lp-300 ml-1 w-1/2" }
const _hoisted_16 = { class: "font-medium mb-1" }
const _hoisted_17 = { class: "break-all" }
const _hoisted_18 = { class: "text-black-lp-300" }
const _hoisted_19 = { class: "font-medium mb-1" }
const _hoisted_20 = { class: "text-black-lp-300" }
const _hoisted_21 = { class: "font-medium mb-1" }
const _hoisted_22 = { class: "text-black-lp-300 flex" }
const _hoisted_23 = { class: "w-1/2 mr-1 break-all" }
const _hoisted_24 = { class: "font-medium mb-1" }
const _hoisted_25 = { class: "w-1/2 ml-1" }
const _hoisted_26 = { class: "font-medium mb-1" }
const _hoisted_27 = { class: "text-black-lp-300 flex" }
const _hoisted_28 = { class: "w-1/2 mr-1" }
const _hoisted_29 = { class: "font-medium mb-1" }
const _hoisted_30 = { class: "w-1/2 ml-1" }
const _hoisted_31 = { class: "font-medium mb-1" }
const _hoisted_32 = { class: "text-black-lp-300 flex mb-1" }
const _hoisted_33 = { class: "w-1/2 mr-1" }
const _hoisted_34 = { class: "font-medium" }
const _hoisted_35 = {
  class: "w-1/2 ml-1",
  "data-testid": "client-branch-detail-need-split-so"
}
const _hoisted_36 = {
  class: "font-medium",
  "data-testid": "client-branch-detail-need-split-so-label"
}
const _hoisted_37 = { "data-testid": "client-branch-detail-need-split-so-value" }
const _hoisted_38 = { class: "p-0" }
const _hoisted_39 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_40 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_41 = {
  key: 0,
  class: "flex flex-col mt-6 gap-6"
}
const _hoisted_42 = { class: "text-black-lp-300 flex text-sm" }
const _hoisted_43 = { class: "w-1/2 mr-1" }
const _hoisted_44 = { class: "font-medium mb-1" }
const _hoisted_45 = { class: "w-1/2 ml-1" }
const _hoisted_46 = { class: "font-medium mb-1" }
const _hoisted_47 = {
  key: 0,
  class: "flex flex-wrap gap-2 pt-2"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 1,
  class: "font-medium text-black-lp-300 mt-6"
}
const _hoisted_50 = { class: "p-0" }
const _hoisted_51 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_52 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_53 = { class: "flex flex-col mt-6 text-sm" }
const _hoisted_54 = { class: "text-black-lp-300 flex" }
const _hoisted_55 = { class: "w-1/2 mr-1 break-all" }
const _hoisted_56 = { class: "font-medium mb-1" }
const _hoisted_57 = { class: "w-1/2 ml-1" }
const _hoisted_58 = { class: "font-medium mb-1" }
const _hoisted_59 = { class: "flex flex-col mt-4 text-sm" }
const _hoisted_60 = { class: "text-black-lp-300 flex" }
const _hoisted_61 = { class: "w-1/2 mr-1 break-all" }
const _hoisted_62 = { class: "font-medium mb-1" }
const _hoisted_63 = { class: "w-1/2 ml-1" }
const _hoisted_64 = { class: "font-medium mb-1" }
const _hoisted_65 = { class: "p-0" }
const _hoisted_66 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_67 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_68 = { class: "flex flex-col mt-6 text-sm" }
const _hoisted_69 = { class: "text-black-lp-300 mb-3 flex" }
const _hoisted_70 = { class: "w-1/2 mr-1" }
const _hoisted_71 = { class: "font-medium mb-1" }
const _hoisted_72 = { class: "w-1/2 ml-1" }
const _hoisted_73 = { class: "font-medium mb-1" }
const _hoisted_74 = { class: "flex flex-col mt-4 text-sm" }
const _hoisted_75 = { class: "text-black-lp-300 mb-3 flex" }
const _hoisted_76 = { class: "w-1/2 mr-1 break-all" }
const _hoisted_77 = { class: "font-medium mb-1" }
const _hoisted_78 = { class: "w-1/2 ml-1 break-all" }
const _hoisted_79 = { class: "font-medium mb-1" }
const _hoisted_80 = { class: "font-semibold text-base text-black-lp-200 mt-10" }
const _hoisted_81 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_82 = { class: "flex flex-col mt-6 text-sm" }
const _hoisted_83 = { class: "text-black-lp-300 mb-3" }
const _hoisted_84 = { class: "font-medium mb-1" }
const _hoisted_85 = { class: "p-0" }
const _hoisted_86 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_87 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_88 = { class: "flex mt-6 items-center" }
const _hoisted_89 = { class: "p-field-checkbox flex flex-row items-center" }
const _hoisted_90 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "max-w-none w-12",
  alt: "cod-logo"
}, null, -1)
const _hoisted_91 = {
  for: "cod",
  class: "ml-2.5 font-semibold"
}
const _hoisted_92 = { class: "ml-2.5 bg-black-lp-200 rounded-md text-white px-3 py-1 font-semibold" }
const _hoisted_93 = { class: "p-field-checkbox flex flex-row items-center" }
const _hoisted_94 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-12",
  alt: "cod-logo"
}, null, -1)
const _hoisted_95 = {
  for: "cod",
  class: "ml-2.5 font-semibold"
}
const _hoisted_96 = { class: "flex flex-col mt-6" }
const _hoisted_97 = { class: "text-black-lp-300 mb-3 flex" }
const _hoisted_98 = { class: "w-1/2 mr-1" }
const _hoisted_99 = { class: "font-medium mb-1" }
const _hoisted_100 = { class: "w-1/2 ml-1" }
const _hoisted_101 = { class: "font-medium mb-1" }
const _hoisted_102 = { class: "p-0" }
const _hoisted_103 = { class: "font-semibold text-base text-black-lp-200" }
const _hoisted_104 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_105 = { class: "flex flex-col mt-6 gap-4" }
const _hoisted_106 = { class: "text-black-lp-300 flex mb-4" }
const _hoisted_107 = { class: "w-1/2 mr-1 break-all" }
const _hoisted_108 = { class: "font-medium mb-1" }
const _hoisted_109 = { class: "w-1/2 ml-1 break-all" }
const _hoisted_110 = { class: "font-medium mb-1" }
const _hoisted_111 = { class: "flex flex-col gap-4 mb-4" }
const _hoisted_112 = { class: "text-black-lp-300 flex" }
const _hoisted_113 = { class: "w-1/2 mr-1" }
const _hoisted_114 = { class: "font-medium mb-1" }
const _hoisted_115 = { class: "w-1/2 ml-1" }
const _hoisted_116 = { class: "font-medium mb-1" }
const _hoisted_117 = { class: "text-black-lp-300" }
const _hoisted_118 = { class: "font-medium mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_managing_country_read_row = _resolveComponent("managing-country-read-row")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CardTabDetail = _resolveComponent("CardTabDetail")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_CardTabDetail, {
      tabs: _ctx.tabs,
      title: _ctx.$t('clientManagement.managementDetail.branchDetailTitle'),
      buttonLabel: _ctx.$t('clientManagement.infoDetailClient.editDetail'),
      onAction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action'))),
      detailClient: _ctx.detailData
    }, {
      "client-info": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('clientManagement.managementDetail.clientInfoTitle')), 1),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedClientInfo").updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedClientInfo").updatedByName), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('clientManagement.managementDetail.clientType')), 1),
              _createVNode("div", null, _toDisplayString(_ctx.detailData.clientType
                    ? _ctx.detailData.clientType
                        .toLowerCase()
                        .replace("client", "klien")[0]
                        .toUpperCase() +
                      _ctx.detailData.clientType
                        .toLowerCase()
                        .replace("client", "klien")
                        .slice(1)
                    : "-"), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('clientManagement.managementDetail.clientId')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.id ? _ctx.detailData.id : "-"), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('clientManagement.managementDetail.clientCode')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCode ? _ctx.detailData.clientCode : "-"), 1)
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.clientBranch.branchClientName')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientName ? _ctx.detailData.clientName : "-"), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('clientManagement.registrationList.columns.alias')), 1),
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.detailData.clientAlias ? _ctx.detailData.clientAlias : "-"), 1)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('clientManagement.managementDetail.address')), 1),
              _createVNode("div", null, _toDisplayString(_ctx.detailData.clientAddress ? _ctx.detailData.clientAddress : "-"), 1)
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('clientManagement.managementDetail.districtCity')), 1),
              _createVNode("div", null, _toDisplayString(_ctx.detailData.clientDistrict.name && _ctx.detailData.clientCity.name
                    ? _ctx.detailData.clientDistrict?.name +
                      " , " +
                      _ctx.detailData.clientCity.name
                    : "-"), 1)
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('clientManagement.managementDetail.email')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientEmail ? _ctx.detailData.clientEmail : "-"), 1)
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('clientManagement.managementDetail.phone')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientPhone
                      ? "+" +
                        (_ctx.isMY
                          ? "60" + _ctx.detailData.clientPhone
                          : _ctx.convertPhoneNumber(_ctx.detailData.clientPhone))
                      : "-"), 1)
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('clientManagement.managementDetail.cod')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientIsCod ? _ctx.$t('clientManagement.managementDetail.yes') : _ctx.$t('clientManagement.managementDetail.no')), 1)
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.deliveryService.deliveryOrder')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientIsDo ? _ctx.$t('clientManagement.managementDetail.yes') : _ctx.$t('clientManagement.managementDetail.no')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('clientManagement.managementDetail.taxRegistrationNumber')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientTaxNumber
                      ? _ctx.isMY
                        ? _ctx.detailData.clientTaxNumber
                        : _ctx.detailData.clientTaxNumber
                            .replace(/\./g, "")
                            .replace(/\-/g, "")
                      : "-"), 1)
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('clientManagement.managementDetail.requiresSOSplit')), 1),
                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.detailData?.clientIsNeedSplitSo ? _ctx.$t('clientManagement.managementDetail.yes') : _ctx.$t('clientManagement.managementDetail.no')), 1)
              ])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_managing_country_read_row, {
                value: _ctx.detailData?.clientManagingCountryName || '-',
                titleClass: "font-medium"
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      "config-return": _withCtx(() => [
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.returnConfig.title')), 1),
          _createVNode("div", _hoisted_40, _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedReturnConfigurationInfo").updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedReturnConfigurationInfo").updatedByName), 1),
          (_ctx.detailData.isReturnConfig)
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.returnConfig.confirmationLimit')), 1),
                    _createVNode("div", null, _toDisplayString(_ctx.detailData.returnConfigLimit
                      ? _ctx.detailData.returnConfigLimit + ` ${_ctx.$t('clientManagement.managementDetail.day')}`
                      : "-"), 1)
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.returnConfig.reasonNeedsConfirmation')), 1),
                    (_ctx.detailData.returnConfigReasonIds)
                      ? (_openBlock(), _createBlock("div", _hoisted_47, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getReasonList(
                      _ctx.detailData.returnConfigReasonIds
                    ), (reason, id) => {
                            return (_openBlock(), _createBlock(_component_Chips, {
                              key: id,
                              color: "white",
                              textColor: "",
                              label: reason,
                              textSize: 14,
                              padding: "p-0"
                            }, null, 8, ["label"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_48, "-"))
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_49, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.returnConfig.noConfiguration')), 1))
        ])
      ]),
      contact: _withCtx(() => [
        _createVNode("div", _hoisted_50, [
          _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('clientManagement.managementDetail.contactInfoTitle')), 1),
          _createVNode("div", _hoisted_52, _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedContactInfo").updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedContactInfo").updatedByName), 1),
          _createVNode("div", _hoisted_53, [
            _createVNode("div", _hoisted_54, [
              _createVNode("div", _hoisted_55, [
                _createVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('clientManagement.managementDetail.name')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.clientContact.name || "-"), 1)
              ]),
              _createVNode("div", _hoisted_57, [
                _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('clientManagement.managementDetail.position')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.clientContact.jobLevel || "-"), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('clientManagement.managementDetail.email')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.clientContact.email || "-"), 1)
              ]),
              _createVNode("div", _hoisted_63, [
                _createVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('clientManagement.managementDetail.phone')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.clientContact.phone
                      ? "+" +
                        (_ctx.isMY
                          ? "60" + _ctx.clientContact.phone
                          : _ctx.convertPhoneNumber(_ctx.clientContact.phone))
                      : "-"), 1)
              ])
            ])
          ])
        ])
      ]),
      return: _withCtx(() => [
        _createVNode("div", _hoisted_65, [
          _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.sttReturn.title')), 1),
          _createVNode("div", _hoisted_67, _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedReturnInfo").updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedReturnInfo").updatedByName), 1),
          _createVNode("div", _hoisted_68, [
            _createVNode("div", _hoisted_69, [
              _createVNode("div", _hoisted_70, [
                _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.sttReturn.receiverName')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCodReject.clientCodName
                      ? _ctx.detailData.clientCodReject.clientCodName
                      : "-"), 1)
              ]),
              _createVNode("div", _hoisted_72, [
                _createVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.sttReturn.phoneNumber')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCodReject.clientCodPhone
                      ? "+" +
                        (_ctx.isMY
                          ? "60" + _ctx.detailData.clientCodReject.clientCodPhone
                          : _ctx.convertPhoneNumber(_ctx.detailData.clientCodReject.clientCodPhone))
                      : "-"), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_74, [
            _createVNode("div", _hoisted_75, [
              _createVNode("div", _hoisted_76, [
                _createVNode("div", _hoisted_77, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.sttReturn.address')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCodReject.clientCodAddress
                      ? _ctx.detailData.clientCodReject.clientCodAddress
                      : "-"), 1)
              ]),
              _createVNode("div", _hoisted_78, [
                _createVNode("div", _hoisted_79, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.sttReturn.districtCity')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCodReject.clientCodDistrict?.name
                      ? _ctx.detailData.clientCodReject.clientCodDistrict?.name
                      : "-"), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_80, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.deliveryOrderReturn.title')), 1),
          _createVNode("div", _hoisted_81, _toDisplayString(_ctx.newestUpdatedClientDOPaymentType.updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.newestUpdatedClientDOPaymentType.updatedByName), 1),
          _createVNode("div", _hoisted_82, [
            _createVNode("div", _hoisted_83, [
              _createVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.deliveryOrderReturn.paymentType')), 1),
              _createVNode("div", null, _toDisplayString(_ctx.detailData.clientBranchDoPaymentType
                    ? _ctx.detailData.clientBranchDoPaymentType === "paid"
                      ? _ctx.$t('clientManagement.registrationBranchForm.deliveryOrderReturn.paid')
                      : _ctx.$t('clientManagement.registrationBranchForm.deliveryOrderReturn.free')
                    : "-"), 1)
            ])
          ])
        ])
      ]),
      cod: _withCtx(() => [
        _createVNode("div", _hoisted_85, [
          _createVNode("div", _hoisted_86, _toDisplayString(_ctx.$t('clientManagement.managementDetail.cod')), 1),
          _createVNode("div", _hoisted_87, _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedCodInfo").updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedCodInfo").updatedByName), 1),
          _createVNode("div", _hoisted_88, [
            (_ctx.detailData.clientIsCod)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "col-span-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.deliveryService.cashOnDelivery')), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_92, _toDisplayString(_ctx.$t(_ctx.detailData.clientCodConfigAmount.name
                  ? _ctx.detailData.clientCodConfigAmount.name
                  : "-")), 1)
          ]),
          (_ctx.detailData.clientIsDfod)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "col-span-2 mt-6"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_93, [
                    _hoisted_94,
                    _createVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.codType.deliveryFeeOnDelivery')), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_96, [
            _createVNode("div", _hoisted_97, [
              _createVNode("div", _hoisted_98, [
                _createVNode("div", _hoisted_99, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.codType.codFee')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCodReject.clientCodCommission
                      ? _ctx.detailData.clientCodReject.clientCodCommission + "%"
                      : "-"), 1)
              ]),
              _createVNode("div", _hoisted_100, [
                _createVNode("div", _hoisted_101, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.codType.codDiscountPercentage')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientCodShipmentDiscount
                      ? _ctx.detailData.clientCodShipmentDiscount + "%"
                      : "-"), 1)
              ])
            ])
          ])
        ])
      ]),
      "detail-parent-client": _withCtx(() => [
        _createVNode("div", _hoisted_102, [
          _createVNode("div", _hoisted_103, _toDisplayString(_ctx.$t('clientManagement.managementDetail.parentClientDetail')), 1),
          _createVNode("div", _hoisted_104, _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedClientParentInfo").updatedAt) + " " + _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.by')) + " " + _toDisplayString(_ctx.getNewestUpdatedByKey("newestUpdatedClientParentInfo").updatedByName), 1),
          _createVNode("div", _hoisted_105, [
            _createVNode("div", _hoisted_106, [
              _createVNode("div", _hoisted_107, [
                _createVNode("div", _hoisted_108, _toDisplayString(_ctx.$t('clientManagement.managementDetail.parentClientName')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.detailData.clientParentName
                      ? _ctx.detailData.clientParentName
                      : "-"), 1)
              ]),
              _createVNode("div", _hoisted_109, [
                _createVNode("div", _hoisted_110, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.parentClientDetail.partnerPosName')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.clientPartner.clientPartnerName || "-"), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_111, [
            _createVNode("div", _hoisted_112, [
              _createVNode("div", _hoisted_113, [
                _createVNode("div", _hoisted_114, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.parentClientDetail.posCommission')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.posCommision ? _ctx.posCommision + "%" : "-"), 1)
              ]),
              _createVNode("div", _hoisted_115, [
                _createVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.parentClientDetail.commissionType')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.clientPartner.clientPartnerNumeratorCommission), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_117, [
            _createVNode("div", _hoisted_118, _toDisplayString(_ctx.$t('clientManagement.registrationBranchForm.parentClientDetail.commissionNumerator')), 1),
            _createVNode("div", null, _toDisplayString(_ctx.clientPartner.clientPartnerQuantifierCommission), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["tabs", "title", "buttonLabel", "detailClient"])
  ]))
}